module.exports = __webpack_public_path__ + "img/3chargeStage.afc6e061.jpg";